import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import SnackbarHost from './components/common/SnackbarHost';
import Login from './pages/auth/Login';
import './App.css';
import Layout from './components/layout';
import TripPage from './pages/trips/TripPage';
import TripsPage from './pages/trips/TripsPage';
import RatesPage from './pages/trips/RatesPage';
import HomePage from './pages/reservations/HomePage';
import ClientsPage from './pages/reservations/ClientsPage';
import ServicesPage from './pages/reservations/ServicesPage';
import OperatorsPage from './pages/reservations/OperatorsPage';
import FilesPage from './pages/reservations/FilesPage';
import FilePage from './pages/reservations/FilePage';
import FilePrintPage from './pages/reservations/FilePrintPage';
import ReceiptPrintPage from './pages/reservations/ReceiptPrintPage';
import ServicePage from './pages/reservations/ServicePage';
import ExpensesPage from './pages/reservations/ExpensesPage';
import ProfitabilityPage from './pages/reservations/ProfitabilityPage';

const AppContent = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading-container">Cargando...</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={
        isAuthenticated ? <Navigate to="/backoffice" replace /> : <Login />
      } />
      
      <Route path="/" element={
        <ProtectedRoute>
          <Navigate to="/backoffice" replace />
        </ProtectedRoute>
      } />

      <Route path="/backoffice" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <HomePage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/backoffice/clientes" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <ClientsPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/backoffice/servicios" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <ServicesPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/backoffice/servicio/:id" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <ServicePage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/backoffice/operadores" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <OperatorsPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/backoffice/gastos" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <ExpensesPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/backoffice/rentabilidad" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <ProfitabilityPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/backoffice/fichas" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <FilesPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/backoffice/ficha/:id" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <FilePage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/backoffice/ficha/:id/print" element={
        <ProtectedRoute>
          {/* Print view: sin Layout para que el PDF incluya solo la ficha */}
          <FilePrintPage />
        </ProtectedRoute>
      } />

      <Route path="/backoffice/ficha/:id/recibo" element={
        <ProtectedRoute>
          {/* Print view: sin Layout para que el PDF incluya solo el recibo */}
          <ReceiptPrintPage />
        </ProtectedRoute>
      } />

      <Route path="/paquetes" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <TripsPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/paquete/nuevo" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <TripPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/paquete/:id" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <TripPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/paquete/:id/tarifas" element={
        <ProtectedRoute>
          <Layout>
            <main className="main-content">
              <RatesPage />
            </main>
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <SnackbarHost />
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
